import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useOcPolling } from "oc/hooks";

const GET_CONTRACT_CALENDARS = gql`
  query contractCalendar(
    $contract: String!
    $startDate: Date!
    $endDate: Date!
  ) {
    contractCalendar(
      contract: $contract
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

interface ContractCalendarProps {
  contract: string;
  startDate: string;
  endDate: string;
}

export const useOcContractCalendar = ({
  contract,
  startDate,
  endDate,
}: ContractCalendarProps) => {
  const { data, loading, error } = useQuery(GET_CONTRACT_CALENDARS, {
    skip: !contract || !startDate || !endDate,
    pollInterval: useOcPolling(1000 * 60),
    variables: { contract, startDate, endDate },
  });

  return {
    contractCalendar: data?.contractCalendar,
    contractCalendarLoading: loading,
    contractCalendarError: error,
  };
};

export default useOcContractCalendar;
